/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StyleguideRouteImport } from './routes/styleguide'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as PrivateRouteRouteImport } from './routes/_private/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicRecuperarPasswordRouteImport } from './routes/_public/recuperar-password'
import { Route as PublicPrivacidadRouteImport } from './routes/_public/privacidad'
import { Route as PublicEliminacionDatosRouteImport } from './routes/_public/eliminacion-datos'
import { Route as PublicActivarRouteImport } from './routes/_public/activar'
import { Route as PrivateReportesRouteImport } from './routes/_private/reportes'
import { Route as PrivateMapaRouteImport } from './routes/_private/mapa'
import { Route as PrivateIncidenciasRouteImport } from './routes/_private/incidencias'
import { Route as PrivateDashboardRouteImport } from './routes/_private/dashboard'
import { Route as PrivateConfiguracionRouteImport } from './routes/_private/configuracion'
import { Route as PrivateBitacoraRouteImport } from './routes/_private/bitacora'
import { Route as Private404RouteImport } from './routes/_private/404'
import { Route as Private403RouteImport } from './routes/_private/403'
import { Route as _devPrimitivesRouteImport } from './routes/__dev/primitives'
import { Route as PublicLoginIndexRouteImport } from './routes/_public/login/index'
import { Route as PrivateUsuariosIndexRouteImport } from './routes/_private/usuarios/index'
import { Route as PrivateProyectosIndexRouteImport } from './routes/_private/proyectos/index'
import { Route as PrivateCuentaIndexRouteImport } from './routes/_private/cuenta/index'
import { Route as PublicLoginMfaSetupRouteImport } from './routes/_public/login/mfa-setup'
import { Route as PublicLoginMfaRouteImport } from './routes/_public/login/mfa'
import { Route as PrivateUsuariosNuevoRouteImport } from './routes/_private/usuarios/nuevo'
import { Route as PrivateUsuariosIdRouteImport } from './routes/_private/usuarios/$id'
import { Route as PrivateProyectosNuevoRouteImport } from './routes/_private/proyectos/nuevo'
import { Route as PrivateCuentaSeguridadRouteImport } from './routes/_private/cuenta/seguridad'
import { Route as PrivateProyectosIdIndexRouteImport } from './routes/_private/proyectos/$id/index'
import { Route as PrivateCatalogosSlugIndexRouteImport } from './routes/_private/catalogos/$slug/index'
import { Route as PrivateProyectosIdSeguimientoRouteImport } from './routes/_private/proyectos/$id/seguimiento'
import { Route as PrivateProyectosIdEditarRouteImport } from './routes/_private/proyectos/$id/editar'
import { Route as PrivateProyectosIdCumplimientoRouteImport } from './routes/_private/proyectos/$id/cumplimiento'
import { Route as PrivateProyectosIdContinuarRouteImport } from './routes/_private/proyectos/$id/continuar'

const StyleguideRoute = StyleguideRouteImport.update({
  id: '/styleguide',
  path: '/styleguide',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRouteRoute = PrivateRouteRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicRecuperarPasswordRoute = PublicRecuperarPasswordRouteImport.update({
  id: '/recuperar-password',
  path: '/recuperar-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicPrivacidadRoute = PublicPrivacidadRouteImport.update({
  id: '/privacidad',
  path: '/privacidad',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicEliminacionDatosRoute = PublicEliminacionDatosRouteImport.update({
  id: '/eliminacion-datos',
  path: '/eliminacion-datos',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicActivarRoute = PublicActivarRouteImport.update({
  id: '/activar',
  path: '/activar',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateReportesRoute = PrivateReportesRouteImport.update({
  id: '/reportes',
  path: '/reportes',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateMapaRoute = PrivateMapaRouteImport.update({
  id: '/mapa',
  path: '/mapa',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateIncidenciasRoute = PrivateIncidenciasRouteImport.update({
  id: '/incidencias',
  path: '/incidencias',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateDashboardRoute = PrivateDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateConfiguracionRoute = PrivateConfiguracionRouteImport.update({
  id: '/configuracion',
  path: '/configuracion',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateBitacoraRoute = PrivateBitacoraRouteImport.update({
  id: '/bitacora',
  path: '/bitacora',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const Private404Route = Private404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const Private403Route = Private403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const _devPrimitivesRoute = _devPrimitivesRouteImport.update({
  id: '/__dev/primitives',
  path: '/primitives',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLoginIndexRoute = PublicLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateUsuariosIndexRoute = PrivateUsuariosIndexRouteImport.update({
  id: '/usuarios/',
  path: '/usuarios/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateProyectosIndexRoute = PrivateProyectosIndexRouteImport.update({
  id: '/proyectos/',
  path: '/proyectos/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateCuentaIndexRoute = PrivateCuentaIndexRouteImport.update({
  id: '/cuenta/',
  path: '/cuenta/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PublicLoginMfaSetupRoute = PublicLoginMfaSetupRouteImport.update({
  id: '/login/mfa-setup',
  path: '/login/mfa-setup',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicLoginMfaRoute = PublicLoginMfaRouteImport.update({
  id: '/login/mfa',
  path: '/login/mfa',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateUsuariosNuevoRoute = PrivateUsuariosNuevoRouteImport.update({
  id: '/usuarios/nuevo',
  path: '/usuarios/nuevo',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateUsuariosIdRoute = PrivateUsuariosIdRouteImport.update({
  id: '/usuarios/$id',
  path: '/usuarios/$id',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateProyectosNuevoRoute = PrivateProyectosNuevoRouteImport.update({
  id: '/proyectos/nuevo',
  path: '/proyectos/nuevo',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateCuentaSeguridadRoute = PrivateCuentaSeguridadRouteImport.update({
  id: '/cuenta/seguridad',
  path: '/cuenta/seguridad',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateProyectosIdIndexRoute = PrivateProyectosIdIndexRouteImport.update({
  id: '/proyectos/$id/',
  path: '/proyectos/$id/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateCatalogosSlugIndexRoute =
  PrivateCatalogosSlugIndexRouteImport.update({
    id: '/catalogos/$slug/',
    path: '/catalogos/$slug/',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateProyectosIdSeguimientoRoute =
  PrivateProyectosIdSeguimientoRouteImport.update({
    id: '/proyectos/$id/seguimiento',
    path: '/proyectos/$id/seguimiento',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateProyectosIdEditarRoute =
  PrivateProyectosIdEditarRouteImport.update({
    id: '/proyectos/$id/editar',
    path: '/proyectos/$id/editar',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateProyectosIdCumplimientoRoute =
  PrivateProyectosIdCumplimientoRouteImport.update({
    id: '/proyectos/$id/cumplimiento',
    path: '/proyectos/$id/cumplimiento',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateProyectosIdContinuarRoute =
  PrivateProyectosIdContinuarRouteImport.update({
    id: '/proyectos/$id/continuar',
    path: '/proyectos/$id/continuar',
    getParentRoute: () => PrivateRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/styleguide': typeof StyleguideRoute
  '/primitives': typeof _devPrimitivesRoute
  '/403': typeof Private403Route
  '/404': typeof Private404Route
  '/bitacora': typeof PrivateBitacoraRoute
  '/configuracion': typeof PrivateConfiguracionRoute
  '/dashboard': typeof PrivateDashboardRoute
  '/incidencias': typeof PrivateIncidenciasRoute
  '/mapa': typeof PrivateMapaRoute
  '/reportes': typeof PrivateReportesRoute
  '/activar': typeof PublicActivarRoute
  '/eliminacion-datos': typeof PublicEliminacionDatosRoute
  '/privacidad': typeof PublicPrivacidadRoute
  '/recuperar-password': typeof PublicRecuperarPasswordRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/cuenta/seguridad': typeof PrivateCuentaSeguridadRoute
  '/proyectos/nuevo': typeof PrivateProyectosNuevoRoute
  '/usuarios/$id': typeof PrivateUsuariosIdRoute
  '/usuarios/nuevo': typeof PrivateUsuariosNuevoRoute
  '/login/mfa': typeof PublicLoginMfaRoute
  '/login/mfa-setup': typeof PublicLoginMfaSetupRoute
  '/cuenta/': typeof PrivateCuentaIndexRoute
  '/proyectos/': typeof PrivateProyectosIndexRoute
  '/usuarios/': typeof PrivateUsuariosIndexRoute
  '/login/': typeof PublicLoginIndexRoute
  '/proyectos/$id/continuar': typeof PrivateProyectosIdContinuarRoute
  '/proyectos/$id/cumplimiento': typeof PrivateProyectosIdCumplimientoRoute
  '/proyectos/$id/editar': typeof PrivateProyectosIdEditarRoute
  '/proyectos/$id/seguimiento': typeof PrivateProyectosIdSeguimientoRoute
  '/catalogos/$slug/': typeof PrivateCatalogosSlugIndexRoute
  '/proyectos/$id/': typeof PrivateProyectosIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/styleguide': typeof StyleguideRoute
  '/primitives': typeof _devPrimitivesRoute
  '/403': typeof Private403Route
  '/404': typeof Private404Route
  '/bitacora': typeof PrivateBitacoraRoute
  '/configuracion': typeof PrivateConfiguracionRoute
  '/dashboard': typeof PrivateDashboardRoute
  '/incidencias': typeof PrivateIncidenciasRoute
  '/mapa': typeof PrivateMapaRoute
  '/reportes': typeof PrivateReportesRoute
  '/activar': typeof PublicActivarRoute
  '/eliminacion-datos': typeof PublicEliminacionDatosRoute
  '/privacidad': typeof PublicPrivacidadRoute
  '/recuperar-password': typeof PublicRecuperarPasswordRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/cuenta/seguridad': typeof PrivateCuentaSeguridadRoute
  '/proyectos/nuevo': typeof PrivateProyectosNuevoRoute
  '/usuarios/$id': typeof PrivateUsuariosIdRoute
  '/usuarios/nuevo': typeof PrivateUsuariosNuevoRoute
  '/login/mfa': typeof PublicLoginMfaRoute
  '/login/mfa-setup': typeof PublicLoginMfaSetupRoute
  '/cuenta': typeof PrivateCuentaIndexRoute
  '/proyectos': typeof PrivateProyectosIndexRoute
  '/usuarios': typeof PrivateUsuariosIndexRoute
  '/login': typeof PublicLoginIndexRoute
  '/proyectos/$id/continuar': typeof PrivateProyectosIdContinuarRoute
  '/proyectos/$id/cumplimiento': typeof PrivateProyectosIdCumplimientoRoute
  '/proyectos/$id/editar': typeof PrivateProyectosIdEditarRoute
  '/proyectos/$id/seguimiento': typeof PrivateProyectosIdSeguimientoRoute
  '/catalogos/$slug': typeof PrivateCatalogosSlugIndexRoute
  '/proyectos/$id': typeof PrivateProyectosIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_private': typeof PrivateRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/styleguide': typeof StyleguideRoute
  '/__dev/primitives': typeof _devPrimitivesRoute
  '/_private/403': typeof Private403Route
  '/_private/404': typeof Private404Route
  '/_private/bitacora': typeof PrivateBitacoraRoute
  '/_private/configuracion': typeof PrivateConfiguracionRoute
  '/_private/dashboard': typeof PrivateDashboardRoute
  '/_private/incidencias': typeof PrivateIncidenciasRoute
  '/_private/mapa': typeof PrivateMapaRoute
  '/_private/reportes': typeof PrivateReportesRoute
  '/_public/activar': typeof PublicActivarRoute
  '/_public/eliminacion-datos': typeof PublicEliminacionDatosRoute
  '/_public/privacidad': typeof PublicPrivacidadRoute
  '/_public/recuperar-password': typeof PublicRecuperarPasswordRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_private/cuenta/seguridad': typeof PrivateCuentaSeguridadRoute
  '/_private/proyectos/nuevo': typeof PrivateProyectosNuevoRoute
  '/_private/usuarios/$id': typeof PrivateUsuariosIdRoute
  '/_private/usuarios/nuevo': typeof PrivateUsuariosNuevoRoute
  '/_public/login/mfa': typeof PublicLoginMfaRoute
  '/_public/login/mfa-setup': typeof PublicLoginMfaSetupRoute
  '/_private/cuenta/': typeof PrivateCuentaIndexRoute
  '/_private/proyectos/': typeof PrivateProyectosIndexRoute
  '/_private/usuarios/': typeof PrivateUsuariosIndexRoute
  '/_public/login/': typeof PublicLoginIndexRoute
  '/_private/proyectos/$id/continuar': typeof PrivateProyectosIdContinuarRoute
  '/_private/proyectos/$id/cumplimiento': typeof PrivateProyectosIdCumplimientoRoute
  '/_private/proyectos/$id/editar': typeof PrivateProyectosIdEditarRoute
  '/_private/proyectos/$id/seguimiento': typeof PrivateProyectosIdSeguimientoRoute
  '/_private/catalogos/$slug/': typeof PrivateCatalogosSlugIndexRoute
  '/_private/proyectos/$id/': typeof PrivateProyectosIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/styleguide'
    | '/primitives'
    | '/403'
    | '/404'
    | '/bitacora'
    | '/configuracion'
    | '/dashboard'
    | '/incidencias'
    | '/mapa'
    | '/reportes'
    | '/activar'
    | '/eliminacion-datos'
    | '/privacidad'
    | '/recuperar-password'
    | '/reset-password'
    | '/cuenta/seguridad'
    | '/proyectos/nuevo'
    | '/usuarios/$id'
    | '/usuarios/nuevo'
    | '/login/mfa'
    | '/login/mfa-setup'
    | '/cuenta/'
    | '/proyectos/'
    | '/usuarios/'
    | '/login/'
    | '/proyectos/$id/continuar'
    | '/proyectos/$id/cumplimiento'
    | '/proyectos/$id/editar'
    | '/proyectos/$id/seguimiento'
    | '/catalogos/$slug/'
    | '/proyectos/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/styleguide'
    | '/primitives'
    | '/403'
    | '/404'
    | '/bitacora'
    | '/configuracion'
    | '/dashboard'
    | '/incidencias'
    | '/mapa'
    | '/reportes'
    | '/activar'
    | '/eliminacion-datos'
    | '/privacidad'
    | '/recuperar-password'
    | '/reset-password'
    | '/cuenta/seguridad'
    | '/proyectos/nuevo'
    | '/usuarios/$id'
    | '/usuarios/nuevo'
    | '/login/mfa'
    | '/login/mfa-setup'
    | '/cuenta'
    | '/proyectos'
    | '/usuarios'
    | '/login'
    | '/proyectos/$id/continuar'
    | '/proyectos/$id/cumplimiento'
    | '/proyectos/$id/editar'
    | '/proyectos/$id/seguimiento'
    | '/catalogos/$slug'
    | '/proyectos/$id'
  id:
    | '__root__'
    | '/'
    | '/_private'
    | '/_public'
    | '/styleguide'
    | '/__dev/primitives'
    | '/_private/403'
    | '/_private/404'
    | '/_private/bitacora'
    | '/_private/configuracion'
    | '/_private/dashboard'
    | '/_private/incidencias'
    | '/_private/mapa'
    | '/_private/reportes'
    | '/_public/activar'
    | '/_public/eliminacion-datos'
    | '/_public/privacidad'
    | '/_public/recuperar-password'
    | '/_public/reset-password'
    | '/_private/cuenta/seguridad'
    | '/_private/proyectos/nuevo'
    | '/_private/usuarios/$id'
    | '/_private/usuarios/nuevo'
    | '/_public/login/mfa'
    | '/_public/login/mfa-setup'
    | '/_private/cuenta/'
    | '/_private/proyectos/'
    | '/_private/usuarios/'
    | '/_public/login/'
    | '/_private/proyectos/$id/continuar'
    | '/_private/proyectos/$id/cumplimiento'
    | '/_private/proyectos/$id/editar'
    | '/_private/proyectos/$id/seguimiento'
    | '/_private/catalogos/$slug/'
    | '/_private/proyectos/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRouteRoute: typeof PrivateRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  StyleguideRoute: typeof StyleguideRoute
  _devPrimitivesRoute: typeof _devPrimitivesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/styleguide': {
      id: '/styleguide'
      path: '/styleguide'
      fullPath: '/styleguide'
      preLoaderRoute: typeof StyleguideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/recuperar-password': {
      id: '/_public/recuperar-password'
      path: '/recuperar-password'
      fullPath: '/recuperar-password'
      preLoaderRoute: typeof PublicRecuperarPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/privacidad': {
      id: '/_public/privacidad'
      path: '/privacidad'
      fullPath: '/privacidad'
      preLoaderRoute: typeof PublicPrivacidadRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/eliminacion-datos': {
      id: '/_public/eliminacion-datos'
      path: '/eliminacion-datos'
      fullPath: '/eliminacion-datos'
      preLoaderRoute: typeof PublicEliminacionDatosRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/activar': {
      id: '/_public/activar'
      path: '/activar'
      fullPath: '/activar'
      preLoaderRoute: typeof PublicActivarRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/reportes': {
      id: '/_private/reportes'
      path: '/reportes'
      fullPath: '/reportes'
      preLoaderRoute: typeof PrivateReportesRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/mapa': {
      id: '/_private/mapa'
      path: '/mapa'
      fullPath: '/mapa'
      preLoaderRoute: typeof PrivateMapaRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/incidencias': {
      id: '/_private/incidencias'
      path: '/incidencias'
      fullPath: '/incidencias'
      preLoaderRoute: typeof PrivateIncidenciasRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/dashboard': {
      id: '/_private/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof PrivateDashboardRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/configuracion': {
      id: '/_private/configuracion'
      path: '/configuracion'
      fullPath: '/configuracion'
      preLoaderRoute: typeof PrivateConfiguracionRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/bitacora': {
      id: '/_private/bitacora'
      path: '/bitacora'
      fullPath: '/bitacora'
      preLoaderRoute: typeof PrivateBitacoraRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/404': {
      id: '/_private/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof Private404RouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/403': {
      id: '/_private/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof Private403RouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/__dev/primitives': {
      id: '/__dev/primitives'
      path: '/primitives'
      fullPath: '/primitives'
      preLoaderRoute: typeof _devPrimitivesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/login/': {
      id: '/_public/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof PublicLoginIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/usuarios/': {
      id: '/_private/usuarios/'
      path: '/usuarios'
      fullPath: '/usuarios/'
      preLoaderRoute: typeof PrivateUsuariosIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/proyectos/': {
      id: '/_private/proyectos/'
      path: '/proyectos'
      fullPath: '/proyectos/'
      preLoaderRoute: typeof PrivateProyectosIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/cuenta/': {
      id: '/_private/cuenta/'
      path: '/cuenta'
      fullPath: '/cuenta/'
      preLoaderRoute: typeof PrivateCuentaIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_public/login/mfa-setup': {
      id: '/_public/login/mfa-setup'
      path: '/login/mfa-setup'
      fullPath: '/login/mfa-setup'
      preLoaderRoute: typeof PublicLoginMfaSetupRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/login/mfa': {
      id: '/_public/login/mfa'
      path: '/login/mfa'
      fullPath: '/login/mfa'
      preLoaderRoute: typeof PublicLoginMfaRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/usuarios/nuevo': {
      id: '/_private/usuarios/nuevo'
      path: '/usuarios/nuevo'
      fullPath: '/usuarios/nuevo'
      preLoaderRoute: typeof PrivateUsuariosNuevoRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/usuarios/$id': {
      id: '/_private/usuarios/$id'
      path: '/usuarios/$id'
      fullPath: '/usuarios/$id'
      preLoaderRoute: typeof PrivateUsuariosIdRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/proyectos/nuevo': {
      id: '/_private/proyectos/nuevo'
      path: '/proyectos/nuevo'
      fullPath: '/proyectos/nuevo'
      preLoaderRoute: typeof PrivateProyectosNuevoRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/cuenta/seguridad': {
      id: '/_private/cuenta/seguridad'
      path: '/cuenta/seguridad'
      fullPath: '/cuenta/seguridad'
      preLoaderRoute: typeof PrivateCuentaSeguridadRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/proyectos/$id/': {
      id: '/_private/proyectos/$id/'
      path: '/proyectos/$id'
      fullPath: '/proyectos/$id/'
      preLoaderRoute: typeof PrivateProyectosIdIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/catalogos/$slug/': {
      id: '/_private/catalogos/$slug/'
      path: '/catalogos/$slug'
      fullPath: '/catalogos/$slug/'
      preLoaderRoute: typeof PrivateCatalogosSlugIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/proyectos/$id/seguimiento': {
      id: '/_private/proyectos/$id/seguimiento'
      path: '/proyectos/$id/seguimiento'
      fullPath: '/proyectos/$id/seguimiento'
      preLoaderRoute: typeof PrivateProyectosIdSeguimientoRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/proyectos/$id/editar': {
      id: '/_private/proyectos/$id/editar'
      path: '/proyectos/$id/editar'
      fullPath: '/proyectos/$id/editar'
      preLoaderRoute: typeof PrivateProyectosIdEditarRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/proyectos/$id/cumplimiento': {
      id: '/_private/proyectos/$id/cumplimiento'
      path: '/proyectos/$id/cumplimiento'
      fullPath: '/proyectos/$id/cumplimiento'
      preLoaderRoute: typeof PrivateProyectosIdCumplimientoRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/proyectos/$id/continuar': {
      id: '/_private/proyectos/$id/continuar'
      path: '/proyectos/$id/continuar'
      fullPath: '/proyectos/$id/continuar'
      preLoaderRoute: typeof PrivateProyectosIdContinuarRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
  }
}

interface PrivateRouteRouteChildren {
  Private403Route: typeof Private403Route
  Private404Route: typeof Private404Route
  PrivateBitacoraRoute: typeof PrivateBitacoraRoute
  PrivateConfiguracionRoute: typeof PrivateConfiguracionRoute
  PrivateDashboardRoute: typeof PrivateDashboardRoute
  PrivateIncidenciasRoute: typeof PrivateIncidenciasRoute
  PrivateMapaRoute: typeof PrivateMapaRoute
  PrivateReportesRoute: typeof PrivateReportesRoute
  PrivateCuentaSeguridadRoute: typeof PrivateCuentaSeguridadRoute
  PrivateProyectosNuevoRoute: typeof PrivateProyectosNuevoRoute
  PrivateUsuariosIdRoute: typeof PrivateUsuariosIdRoute
  PrivateUsuariosNuevoRoute: typeof PrivateUsuariosNuevoRoute
  PrivateCuentaIndexRoute: typeof PrivateCuentaIndexRoute
  PrivateProyectosIndexRoute: typeof PrivateProyectosIndexRoute
  PrivateUsuariosIndexRoute: typeof PrivateUsuariosIndexRoute
  PrivateProyectosIdContinuarRoute: typeof PrivateProyectosIdContinuarRoute
  PrivateProyectosIdCumplimientoRoute: typeof PrivateProyectosIdCumplimientoRoute
  PrivateProyectosIdEditarRoute: typeof PrivateProyectosIdEditarRoute
  PrivateProyectosIdSeguimientoRoute: typeof PrivateProyectosIdSeguimientoRoute
  PrivateCatalogosSlugIndexRoute: typeof PrivateCatalogosSlugIndexRoute
  PrivateProyectosIdIndexRoute: typeof PrivateProyectosIdIndexRoute
}

const PrivateRouteRouteChildren: PrivateRouteRouteChildren = {
  Private403Route: Private403Route,
  Private404Route: Private404Route,
  PrivateBitacoraRoute: PrivateBitacoraRoute,
  PrivateConfiguracionRoute: PrivateConfiguracionRoute,
  PrivateDashboardRoute: PrivateDashboardRoute,
  PrivateIncidenciasRoute: PrivateIncidenciasRoute,
  PrivateMapaRoute: PrivateMapaRoute,
  PrivateReportesRoute: PrivateReportesRoute,
  PrivateCuentaSeguridadRoute: PrivateCuentaSeguridadRoute,
  PrivateProyectosNuevoRoute: PrivateProyectosNuevoRoute,
  PrivateUsuariosIdRoute: PrivateUsuariosIdRoute,
  PrivateUsuariosNuevoRoute: PrivateUsuariosNuevoRoute,
  PrivateCuentaIndexRoute: PrivateCuentaIndexRoute,
  PrivateProyectosIndexRoute: PrivateProyectosIndexRoute,
  PrivateUsuariosIndexRoute: PrivateUsuariosIndexRoute,
  PrivateProyectosIdContinuarRoute: PrivateProyectosIdContinuarRoute,
  PrivateProyectosIdCumplimientoRoute: PrivateProyectosIdCumplimientoRoute,
  PrivateProyectosIdEditarRoute: PrivateProyectosIdEditarRoute,
  PrivateProyectosIdSeguimientoRoute: PrivateProyectosIdSeguimientoRoute,
  PrivateCatalogosSlugIndexRoute: PrivateCatalogosSlugIndexRoute,
  PrivateProyectosIdIndexRoute: PrivateProyectosIdIndexRoute,
}

const PrivateRouteRouteWithChildren = PrivateRouteRoute._addFileChildren(
  PrivateRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicActivarRoute: typeof PublicActivarRoute
  PublicEliminacionDatosRoute: typeof PublicEliminacionDatosRoute
  PublicPrivacidadRoute: typeof PublicPrivacidadRoute
  PublicRecuperarPasswordRoute: typeof PublicRecuperarPasswordRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicLoginMfaRoute: typeof PublicLoginMfaRoute
  PublicLoginMfaSetupRoute: typeof PublicLoginMfaSetupRoute
  PublicLoginIndexRoute: typeof PublicLoginIndexRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicActivarRoute: PublicActivarRoute,
  PublicEliminacionDatosRoute: PublicEliminacionDatosRoute,
  PublicPrivacidadRoute: PublicPrivacidadRoute,
  PublicRecuperarPasswordRoute: PublicRecuperarPasswordRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicLoginMfaRoute: PublicLoginMfaRoute,
  PublicLoginMfaSetupRoute: PublicLoginMfaSetupRoute,
  PublicLoginIndexRoute: PublicLoginIndexRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRouteRoute: PrivateRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  StyleguideRoute: StyleguideRoute,
  _devPrimitivesRoute: _devPrimitivesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
